require('sass/blocks/containers/disclaimer.scss');

const React = require('react');
const PropTypes = require('prop-types');

const Disclaimer = ({ children }) => {
    return <p className="prospects-disclaimer">{children}</p>;
};

Disclaimer.propTypes = {
    children: PropTypes.string.isRequired,
};

module.exports.constructor = Disclaimer;
module.exports = Disclaimer;
